// @ts-nocheck
import { takeLatest } from 'redux-saga/effects';
import { createFetchColumnsSaga, createFetchOrderDataSaga } from 'pages/orderShared/createOrderSagas';
import * as slice from './reducer';
import * as sagaActions from './sagaActions';
import * as constants from './constants';

const handleFetchColumns = createFetchColumnsSaga({
	primaryGroupKey: 'sku',
	primaryKeywords: constants.COLUMN_SKU_KW,
	columnKeys: ['sku', 'store', 'warehouse', 'order'],
	logPrefix: '[OBS-Store]',
	slice,
	constants,
});

const handleFetchOrderData = createFetchOrderDataSaga({
	selectRowKey: constants.SELECT_ROW_KEY,
	logPrefix: '[OBS-Store]',
	slice,
	constants,
});

export default function* rootSaga() {
	return [
		yield takeLatest(sagaActions.fetchStoreColumns, handleFetchColumns),
		yield takeLatest(sagaActions.fetchStoreOrderData, handleFetchOrderData),
	];
}
